import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IRouteReducerSliceStateInit } from "../slice_interface";
import {
  ICouponPincodeListingResponseData,
  ICouponServiceListResponseData,
  ICouponsListingResponseData,
} from "@/api_framework/api_modals/coupon";

export interface ICouponServiceState {
  couponList: ICouponServiceListResponseData[];
  couponListing: ICouponsListingResponseData;
  pincodeListing: ICouponPincodeListingResponseData[];
}
export interface ICouponInitialState extends IRouteReducerSliceStateInit {
  state: ICouponServiceState;
}

const initialState: ICouponInitialState = {
  state: {
    couponList: [],
    couponListing: null,
    pincodeListing: [],
  },
};

const couponserviceSlice = createSlice({
  name: "coupon_service_slice",
  initialState: initialState,
  reducers: {
    // RESET_INVENTORY: () => {
    //   return initialState;
    // },
    setCouponList: (
      state,
      action: PayloadAction<{
        data: ICouponServiceListResponseData[];
      }>,
    ) => {
      state.state.couponList = action.payload.data;
    },
    setCouponListing: (
      state,
      action: PayloadAction<{
        data: ICouponsListingResponseData;
      }>,
    ) => {
      state.state.couponListing = action.payload.data;
    },
    setPincodeListing: (
      state,
      action: PayloadAction<{
        data: ICouponPincodeListingResponseData[];
      }>,
    ) => {
      state.state.pincodeListing = action.payload.data;
    },
  },
});

export const { setCouponList, setCouponListing, setPincodeListing } = couponserviceSlice.actions;
export default couponserviceSlice.reducer;
